export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export enum Background {
  Dark = 'Dark',
  Light = 'Light',
}

export type Block =
  | VideoListBlock
  | PathwayListBlock
  | NewsBlock
  | ImageArrayBlock
  | IntroVideoBlock
  | IntroImageBlock
  | PartnersBlock
  | ExpertsListBlock
  | CatalogueOfCategoriesBlock
  | OriginsBlock
  | QuotesListBlock
  | CtaBlock
  | ForEnterprise
  | AllProfessionals
  | TrustpilotBlock
  | ContactFormBlock
  | MeetTheTeam
  | WeAreBlock;

export type CatalogueOfCategoriesBlock = {
  __typename?: 'CatalogueOfCategoriesBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  title: Scalars['String'];
  slug: Scalars['String'];
};

export type BlogCategorySearchFilter = {
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  user?: Maybe<User>;
  category_id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  slug: Scalars['String'];
  post_content: Scalars['JSON'];
  published_at: Scalars['String'];
  seo_title?: Maybe<Scalars['String']>;
  seo_description?: Maybe<Scalars['String']>;
  seo_image?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  post_introduction?: Maybe<Scalars['String']>;
  is_pinned: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  url_text?: Maybe<Scalars['String']>;
  url_link?: Maybe<Scalars['String']>;
};

export type ContactUs = {
  email?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
};

export type Content = TextContent | ImageContent;

export enum Display {
  Slider = 'Slider',
  Block = 'Block',
}

export type ExpertItem = {
  __typename?: 'ExpertItem';
  ranking?: Maybe<Scalars['Int']>;
  expert?: Maybe<Pathway>;
};

export type ExpertsListBlock = {
  __typename?: 'ExpertsListBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  items?: Maybe<Array<Maybe<ExpertItem>>>;
};

export type ImageArrayBlock = {
  __typename?: 'ImageArrayBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ImageItem>>>;
  background?: Maybe<Background>;
  button_text?: Maybe<Scalars['String']>;
  button_url?: Maybe<Scalars['String']>;
  desktop_image?: Maybe<Scalars['String']>;
  type_image?: Maybe<Scalars['String']>;
};

export type AllProfessionals = {
  __typename?: 'AllProfessionals';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  image?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Maybe<AllProfItem>>>;
};

export type AllProfItem = {
  __typename?: 'AllProfItem';
  title?: Maybe<Scalars['String']>;
  sub_title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type ImageContent = {
  __typename?: 'ImageContent';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  mobile_image?: Maybe<Scalars['String']>;
  is_background?: Maybe<Scalars['Boolean']>;
};

export type ImageItem = {
  __typename?: 'ImageItem';
  image?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ForEnterprise = {
  __typename?: 'ForEnterprise';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  button_text?: Maybe<Scalars['String']>;
  button_url?: Maybe<Scalars['String']>;
  sub_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Maybe<EnterpriseItem>>>;
};

export type EnterpriseItem = {
  __typename?: 'EnterpriseItem';
  title?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
};

export type TrustpilotBlock = {
  __typename?: 'TrustpilotBlock';
  background?: Maybe<Background>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  trustpilot_image?: Maybe<Scalars['String']>;
  trustpilot_url?: Maybe<Scalars['String']>;
};

export type IntroImageBlock = {
  __typename?: 'IntroImageBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  preview_image_url?: Maybe<Scalars['String']>;
  button_url?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  gradient?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Background>;
  usp_blocks?: Maybe<Array<Maybe<Usp_Block>>>;
};

export type IntroVideoBlock = {
  __typename?: 'IntroVideoBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  preview_video_url?: Maybe<Scalars['String']>;
  preview_image_url?: Maybe<Scalars['String']>;
  button_url?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  gradient?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Background>;
  heading_highlight_color?: Maybe<Scalars['String']>;
  watch_video_button_text?: Maybe<Scalars['String']>;
  usp_blocks?: Maybe<Array<Maybe<Usp_Block>>>;
};

export type Usp_Block = {
  __typename?: 'USP_Block';
  ranking?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  seo_image_name?: Maybe<Scalars['String']>;
  label_text?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  contact_us?: Maybe<Scalars['Int']>;
  AddVideoInWatchList?: Maybe<Scalars['Int']>;
  DeleteVideoFromWatchList?: Maybe<Scalars['Int']>;
  check_quiz_answers?: Maybe<QuizPassedResult>;
  createAssignment?: Maybe<Assignment>;
  createAssignmentCPD?: Maybe<Assignment>;
  createAssignmentHours?: Maybe<Assignment>;
  acknowledgeAssignment: Maybe<Scalars['Int']>;
  deleteAssignment: Maybe<Scalars['Int']>;
  updateAssignment: Maybe<Scalars['Int']>;
  joinTeamByInviteHash?: Maybe<Team>;
  editCompany?: Maybe<Company>;
  addLearnerToTeam?: Maybe<LearnerInfo>;
  createTeam?: Maybe<Team>;
  updateTeam?: Maybe<Scalars['Int']>;
  deleteTeam?: Maybe<Scalars['Int']>;
  updateMemberRole?: Maybe<Scalars['Int']>;
  moveLearnerToOtherTeam?: Maybe<Scalars['Int']>;
  removeLearnerFromCompany?: Maybe<Scalars['Int']>;
  sendTeamInviteEmail?: Maybe<TeamInviteLink>;
  updateLearnerInfo?: Maybe<LearnerInfo>;
  updateNotification?: Maybe<Scalars['Int']>;
  createReview: Maybe<Review>;
  removeLearnerFromTeam: Maybe<Scalars['Int']>;
  startCourse?: Maybe<Scalars['Int']>;
};

export type MutationContact_UsArgs = {
  input?: Maybe<ContactUs>;
};

export type AssignmentUpdateInput = {
  assignment_id?: Scalars['ID'];
  due_date?: Maybe<Scalars['String']>;
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentDeleteInput = {
  assignment_id?: Scalars['ID'];
};

export type NewsBlock = {
  __typename?: 'NewsBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  news_limit?: Maybe<Scalars['Int']>;
  background?: Maybe<Background>;
};

export type OrderByClause = {
  field: Scalars['String'];
  order: SortOrder;
};

export enum Orientation {
  Portrait = 'Portrait',
  Lanscape = 'Lanscape',
}

export type OriginsBlock = {
  __typename?: 'OriginsBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  items?: Maybe<Array<Maybe<Content>>>;
};

export type Page = {
  __typename?: 'Page';
  tenant: Tenant;
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<Block>>>;
  created_at?: Maybe<Scalars['String']>;
};

export type PageFilter = {
  url?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NavigationFilter = {
  navigation_type?: Maybe<Array<Maybe<NavigationType>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
};

export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  count: Scalars['Int'];
  currentPage: Scalars['Int'];
  firstItem?: Maybe<Scalars['Int']>;
  hasMorePages: Scalars['Boolean'];
  lastItem?: Maybe<Scalars['Int']>;
  lastPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type Partner = {
  __typename?: 'Partner';
  id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  type?: Maybe<PartnerType>;
  type_id?: Maybe<Scalars['ID']>;
  tenant_id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  url_text?: Maybe<Scalars['String']>;
  url_link?: Maybe<Scalars['String']>;
};

export type PartnersBlock = {
  __typename?: 'PartnersBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  partnerType?: Maybe<PartnerType>;
  background?: Maybe<Background>;
  display?: Maybe<Display>;
};

export type PartnerSearchFilter = {
  type_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PartnerType = {
  __typename?: 'PartnerType';
  id: Scalars['ID'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  name: Scalars['String'];
};

export type PartnerTypeSearchFilter = {
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Pathway = {
  __typename?: 'Pathway';
  id: Scalars['ID'];
  tenant: Tenant;
  name: Scalars['String'];
  description: Scalars['String'];
  image_url: Scalars['String'];
  videos?: Maybe<Array<Maybe<Video>>>;
  count_videos: Scalars['Int'];
  cpd_credits?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  categories?: Maybe<Array<Maybe<VideoCategory>>>;
  difficulty?: Maybe<VideoDifficulty>;
  slug?: Maybe<Scalars['String']>;
  available_quizes?: Maybe<Array<Maybe<Quiz>>>;
  quizes?: Maybe<Array<Maybe<Quiz>>>;
  logo_svg?: Maybe<Scalars['String']>;
  new_videos_added?: Maybe<Scalars['Boolean']>;
};

export type PathwayItem = {
  __typename?: 'PathwayItem';
  ranking?: Maybe<Scalars['Int']>;
  pathway?: Maybe<Pathway>;
};

export type PathwayListBlock = {
  __typename?: 'PathwayListBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  orientation?: Maybe<Orientation>;
  items?: Maybe<Array<Maybe<PathwayItem>>>;
  with_categories?: Maybe<Scalars['Boolean']>;
};

export type PathwaySearchFilter = {
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  image_url?: Maybe<Array<Maybe<Scalars['String']>>>;
  ids?: Maybe<Array<Scalars['Int']>>;
};

export type PostSearchFilter = {
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  category_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  is_pinned?: Maybe<Array<Maybe<Scalars['Int']>>>;
  published?: Maybe<Array<Maybe<Scalars['Int']>>>;
  draft_parent_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Query = {
  __typename?: 'Query';
  getTenants?: Maybe<Array<Tenant>>;
  getTenantByName?: Maybe<Tenant>;
  getUsers?: Maybe<Array<User>>;
  getUserById?: Maybe<User>;
  getPartnerType?: Maybe<Partner>;
  listPartnerTypes?: Maybe<Array<PartnerType>>;
  getPartner?: Maybe<Partner>;
  listPartners?: Maybe<Array<Partner>>;
  getVideoContentGroup?: Maybe<VideoContentGroup>;
  listVideoContentGroups?: Maybe<Array<VideoContentGroup>>;
  getVideoDifficulty?: Maybe<VideoDifficulty>;
  listVideoDifficulties?: Maybe<VideoDifficulty>;
  getVideoCategory?: Maybe<VideoCategory>;
  listVideoCategories?: Maybe<Array<VideoCategory>>;
  listBaseVideoCategories?: Maybe<Array<Maybe<VideoCategory>>>;
  getVideo?: Maybe<Video>;
  listVideos?: Maybe<Array<Video>>;
  listVideosYouMightAlsoLike?: Maybe<Array<Video>>;
  getPathway?: Maybe<Pathway>;
  listPathways?: Maybe<Array<Pathway>>;
  getBlogCategory?: Maybe<Video>;
  listBlogCategories?: Maybe<Array<BlogCategory>>;
  getBlogPost?: Maybe<BlogPost>;
  listPosts?: Maybe<Array<BlogPost>>;
  getAllPages?: Maybe<Array<Page>>;
  getPageByUrl?: Maybe<Page>;
  listContinuingWatchingLinks?: Maybe<Array<Maybe<ContinueWatchingVideoLink>>>;
  ViewedHoursStat?: Maybe<ViewedHoursGroupedByDate>;
  VideosWatchedCountStat?: Maybe<ViewedVideosGroupedByDate>;
  CpdCreditsStat?: Maybe<GroupedCpdCreditsResUsers>;
  PathwaysProgressStat?: Maybe<GroupedViewingPathwaysRes>;
  VideosWatchedByCathegoryStat?: Maybe<Array<Maybe<ViewedVideosGroupedByCategory>>>;
  listDashboard?: Maybe<Array<Maybe<DashBoardContinueWatching>>>;
  listFeaturedExperts?: Maybe<Array<Maybe<Expert>>>;
  listRecommendedVideos?: Maybe<Array<Maybe<Video>>>;
  VideoExistsInUserWatchList?: Maybe<VideoExistsInWatchList>;
  GetWatchList?: Maybe<Array<Maybe<DashVideo>>>;
  UserVideosProgressStat?: Maybe<UserVideosProgressRes>;
  ManagerVideosProgressStat?: Maybe<VideosProgressRes>;
  listlatestVideo?: Maybe<Array<Maybe<DashVideo>>>;
  getAlgoliaApiKey?: Maybe<AlgoliaApiKey>;
  getPathwayPageInfo?: Maybe<PathwayPage>;
  getPathwayLearnerPageInfo?: Maybe<PathwayPageLearner>;
  listYouMightAlsoLikePathways?: Maybe<Array<Maybe<Pathway>>>;
  getFilteredUsers?: Maybe<Array<Maybe<User>>>;
  GetPassedQuizesResultsByHash?: Maybe<QuizPassedResult>;
  GetPassedQuizesResults?: Maybe<Array<Maybe<QuizPassedResult>>>;
  listContactUsDepartments?: Maybe<Array<Maybe<ContactUsDepartment>>>;
  getGeneralListAssignmentsManager: Maybe<Array<Maybe<Assignment>>>;
  getDetailedListAssignmentsManager: Maybe<DetailedAssignmentResponse>;
  get_discover_pathways_detailed_info?: Maybe<Array<Maybe<DiscoverPathwaysDetailedInfo>>>;
  listVideoProgress: Maybe<Array<Maybe<DashVideo>>>;
  getLearnerAssignmentsList?: Maybe<Array<Maybe<AssignmentForLearnerEntity>>>;
  getUsersProgressOnVideo?: Maybe<Array<Maybe<UsersProgressOnVideoFilterResponse>>>;
  get_users_progress_on_pathways_filter?: Maybe<
    Array<Maybe<DiscoverPathwaysDetailedInfofForUsers>>
  >;
  listPricings: Array<Pricing>;
  getLearnerInfo?: Maybe<LearnerInfo>;
  getListTeamsLearnerRelated?: Maybe<Array<Team>>;
  getCompanyLearners?: Maybe<Array<Maybe<LearnerInfo>>>;
  getMySubscriptionCompanyOwnerChargebeeInfo?: Maybe<MySubscriptionCompanyOwnerChargebeeInfo>;
  getMySubscriptionTeamManagerChargebeeInfo?: Maybe<MySubscriptionTeamManagerChargebeeInfo>;
  getMySubscriptionB2BLearnerChargebeeInfo?: Maybe<MySubscriptionB2BLearnerChargebeeInfo>;
  getMySubscriptionB2CLearnerChargebeeInfo?: Maybe<MySubscriptionB2CLearnerChargebeeInfo>;
  getFilteredPricing: Pricing;
  getSubscriptionInfoThankYouPage?: Maybe<SubscriptionChargebeeThankYouInfo>;
  getTeamManagers?: Maybe<Array<LearnerInfo>>;
  getTeamInviteLink?: Maybe<TeamInviteLink>;
  getInviteInfoByHash?: Maybe<TeamInviteInfo>;
  getTeamsList?: Maybe<Array<Team>>;
  getTeamMembers?: Maybe<Array<Maybe<TeamMember>>>;
  getMembersByTeamIdsArray?: Maybe<Array<LearnerInfo>>;
  getTeam?: Maybe<Team>;
  getListEntitiesAssignmentManager?: Maybe<ListEntitiesAssignmentResponse>;
  getEntityAssignmentStatusesInfoManager?: Maybe<Array<Maybe<ProgressByPathway>>>;
  getPathwayAssignmentStatusesInfoManager?: Maybe<Array<Maybe<ProgressByPathway>>>;
  getVideoAssignmentStatusesInfoManager?: Maybe<Array<Maybe<UsersProgressOnVideoFilterResponse>>>;
  getCPDAssignmentDetailedInfoManager?: Maybe<Array<Maybe<ProgressByCpd>>>;
  getHoursAssignmentDetailedInfoManager?: Maybe<Array<Maybe<ProgressByHours>>>;
  listWPTeamMembers: Maybe<Array<WPMemberTeam>>;
  LoginUsersStat: Maybe<LoginsGroupedByDate>;
  LastLoginUsersStat: Maybe<LastLoginUsers>;
  VideosExistInUserWatchList?: Maybe<Array<Maybe<VideosExistInWatchList>>>;
  PathwaysGroupedStat: Maybe<Array<PathwaysGroupedRes>>;
  VideosGroupedStat: Maybe<Array<VideosGroupedRes>>;
  PathwaysDataStat: Maybe<Array<PathwayDataResGrouped>>;
  getGlossaryTerm: Maybe<GlossaryTerm>;
  getListNotificationsForAssignmentLearning: Maybe<Array<NotificationForAssignment>>;
  getListReviewsForEntity: Maybe<ReviewEntity>;
  UsersGroupedStat?: Maybe<GroupedByUsersStatResult>;
  getUserPathwaysProgressStat?: Maybe<PathwaysUserStatResult>;
  GetUsersProgressesByPathway?: Maybe<Array<Maybe<ProgressByPathway>>>;
  listCoursesLogedOut?: Maybe<Array<Maybe<Course>>>;
  listCoursesLogedIn?: Maybe<Array<Maybe<Course>>>;
  getCourse?: Maybe<Course>;
  getUserCoursePathwaysProgressStat?: Maybe<PathwaysUserStatResult>;
  getCourseStatusByHash?: Maybe<CourseStatusModel>;
  getManagerDetailedReportByPathways?: Maybe<DetailedReportByPathways>;
  getManagerDetailedReportByVideos?: Maybe<DetailedReportByVideos>;
  getDetailedReportByPathwaysCsvLink?: Maybe<Scalars['String']>;
  getDetailedReportByVideosCsvLink?: Maybe<Scalars['String']>;
  getPathwayCertificates?: Maybe<Array<Maybe<PathwayCertificate>>>;
};

export type GlossaryTerm = {
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
  subtitle: Maybe<Scalars['String']>;
  definition: Scalars['String'];
  content: Maybe<Scalars['String']>;
  verse_video_id: Maybe<Scalars['String']>;
  videos: Maybe<Array<Maybe<Video>>>;
  glossary_video: Maybe<Video>;
  categories: Maybe<Array<Maybe<VideoCategory>>>;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  seo_name?: Maybe<Scalars['String']>;
  seo_image_name?: Maybe<Scalars['String']>;
  seo_image?: Maybe<Scalars['String']>;
  seo_description?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type GetGlossaryTermArgs = {
  slug: Scalars['String'];
};

export type PathwayDataResGrouped = {
  user_id: Scalars['Int'];
  pathway_videos: Maybe<Array<PathwayVideosDataRes>>;
};

export type PathwayVideosDataRes = {
  pathway: Maybe<Pathway>;
  videos_count: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  test_score?: Maybe<Scalars['String']>;
};

export type PathwayDataFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids: Maybe<Array<Maybe<Scalars['Int']>>>;
  pathway_id?: Maybe<Scalars['Int']>;
  type: TypeAnalytic;
};

export type PathwaysGroupedRes = {
  pathway: Maybe<Pathway>;
  duration: Scalars['Int'];
  cpd_available: Scalars['String'];
  users_completed: Scalars['Int'];
  users_started: Scalars['Int'];
  half_completed: Scalars['Int'];
};

export type pathwaysGroupedFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  type: TypeAnalytic;
};

export type videosGroupedFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  type: TypeAnalytic;
};

export type VideosGroupedRes = {
  story_id?: Maybe<Scalars['Int']>;
  view_duration: Maybe<Scalars['String']>;
  video_url: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  presenter: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  users_completed?: Maybe<Scalars['Int']>;
  users_started?: Maybe<Scalars['Int']>;
  video_categories: Maybe<Scalars['String']>;
  video_duration: Maybe<Scalars['String']>;
};

export type GetTablesAnalytics = Pick<Query, 'PathwaysGroupedStat' | 'VideosGroupedStat'>;

export type GetTablesAnalyticsArgs = {
  pathwaysGroupedFilter: pathwaysGroupedFilter;
  videosGroupedFilter: videosGroupedFilter;
};

export type getUserAnalytics = Pick<
  Query,
  | 'VideosWatchedByCathegoryStat'
  | 'ViewedHoursStat'
  | 'VideosWatchedCountStat'
  | 'PathwaysProgressStat'
  | 'CpdCreditsStat'
  | 'PathwaysDataStat'
  | 'LoginUsersStat'
  | 'LastLoginUsersStat'
  | 'listBaseVideoCategories'
>;

export type getUserAnalyticsArgs = {
  statisticFilter: StatisticFilter;
  viewedHoursFilter: ViewedHoursFilter;
  viewedVideosFilter: ViewedVideosFilter;
  loginStatFilter: LoginUsersFilter;
};

export type LoginsGroupedByDate = {
  grouped_by_dates: Maybe<Array<Maybe<LoginsResDates>>>;
  grouped_by_users: Scalars['JSON'];
  total_count_logins: Scalars['String'];
};

export type LoginsResDates = {
  date: Scalars['String'];
  logins: Scalars['Int'];
  users: Maybe<Array<Maybe<LoginsResUser>>>;
};

export type LoginsResUser = {
  user_id: Scalars['ID'];
  session: Scalars['String'];
  date: Scalars['String'];
};

export type LastLoginUsers = {
  last_logins: Scalars['String'];
};

export type LoginUsersFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Scalars['Int']>>;
  group_by?: Maybe<GroupByPeriod>;
};

export type LoginUsersFilterArgs = {
  loginStatFilter: LoginUsersFilter;
};

export type WPMemberTeam = {
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  team_id: Scalars['ID'];
};

export type TeamFilter = {
  team_ids?: Maybe<Array<Scalars['ID']>>;
};

export type TeamFilterArgs = {
  filter: Maybe<TeamFilter>;
};

export type QueryGetTenantByNameArgs = {
  name: Scalars['String'];
};

export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetPartnerTypeArgs = {
  id: Scalars['ID'];
};

export type QueryListPartnerTypesArgs = {
  filter?: Maybe<PartnerTypeSearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetPartnerArgs = {
  id: Scalars['ID'];
};

export type QueryListPartnersArgs = {
  filter?: Maybe<PartnerSearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetVideoContentGroupArgs = {
  id: Scalars['ID'];
};

export type QueryListVideoContentGroupsArgs = {
  filter?: Maybe<VideoContentGroupSearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetVideoDifficultyArgs = {
  id: Scalars['ID'];
};

export type QueryListVideoDifficultiesArgs = {
  filter?: Maybe<VideoDifficultySearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetVideoCategoryArgs = {
  id: Scalars['ID'];
};

export type QueryListVideoCategoriesArgs = {
  filter?: Maybe<VideoCategorySearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryListBaseVideoCategoriesArgs = {
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetVideoArgs = {
  id: Scalars['ID'];
};

export type QueryListVideosArgs = {
  filter?: Maybe<VideoSearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryListVideosYouMightAlsoLikeArgs = {
  filter?: Maybe<VideoYouMightAlsoLikeFilter>;
};

export type QueryGetPathwayArgs = {
  id: Scalars['ID'];
};

export type QueryListPathwaysArgs = {
  filter?: Maybe<PathwaySearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type GetPathwayForPlayerArgs = {
  slug: string;
};

export type QueryGetBlogCategoryArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryListBlogCategoriesArgs = {
  filter?: Maybe<PostSearchFilter>;
};

export type QueryGetBlogPostArgs = {
  id: Scalars['ID'];
};

export type QueryListPostsArgs = {
  filter?: Maybe<PostSearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type QueryGetPageByUrlArgs = {
  input?: Maybe<PageFilter>;
};

export type Schema = {
  __typename?: 'Schema';
  query?: Maybe<Query>;
  mutation?: Maybe<Mutation>;
};

export type SortOption = {
  field?: Maybe<Scalars['String']>;
  order?: Maybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Tenant = {
  __typename?: 'Tenant';
  id: Scalars['ID'];
  name: Scalars['String'];
  logo_url: Scalars['String'];
  portal_url?: Maybe<Scalars['String']>;
  connection?: Maybe<Scalars['String']>;
  gtm_id?: Maybe<Scalars['String']>;
  custom_css?: Maybe<Scalars['String']>;
  partner_type_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  circle_image_url?: Maybe<Scalars['String']>;
  linkedin_id?: Maybe<Scalars['ID']>;
  auth0_app_id?: Maybe<Scalars['String']>;
  chargebee_site: Scalars['String'];
  linkedin_link?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  facebook_link?: Maybe<Scalars['String']>;
  instagram_link?: Maybe<Scalars['String']>;
  twitter_handle?: Maybe<Scalars['String']>;
  twitter_hashtags_array?: Maybe<Array<Maybe<Scalars['String']>>>;
  fb_name?: Maybe<Scalars['String']>;
  video_bumper_url?: Maybe<Scalars['String']>;
};

export type TextContent = {
  __typename?: 'TextContent';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  button_url?: Maybe<Scalars['String']>;
};

export enum Trashed {
  Only = 'ONLY',
  With = 'WITH',
  Without = 'WITHOUT',
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  avatar?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  description?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  count_videos?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export type Expert = {
  __typename?: 'Expert';
  id: Scalars['ID'];
  avatar?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email: Scalars['String'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  job_title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  count_videos?: Maybe<Scalars['Int']>;
  employee_job_title?: Maybe<Scalars['String']>;
  linkedin_url?: Maybe<Scalars['String']>;
  secondary_image?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Video = {
  __typename?: 'Video';
  id: Scalars['ID'];
  tenant_id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
  category_id?: Maybe<Scalars['ID']>;
  difficulty_id?: Maybe<Scalars['ID']>;
  group_id?: Maybe<Scalars['ID']>;
  preview_url?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  user?: Maybe<User>;
  content_group?: Maybe<VideoContentGroup>;
  categories?: Maybe<Array<Maybe<VideoCategory>>>;
  difficulty?: Maybe<VideoDifficulty>;
  title: Scalars['String'];
  url: Scalars['String'];
  description: Scalars['String'];
  duration: Scalars['Int'];
  ranking?: Maybe<Scalars['Int']>;
  demo: Scalars['Int'];
  created_at?: Maybe<Scalars['String']>;
  executive_summary?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  key_learning_objectives?: Maybe<Array<Maybe<KeyLearningObjective>>>;
  video_url: Scalars['String'];
  verse_video_url: Scalars['String'];
  verse_video_id?: Scalars['String'];
  pathways?: Maybe<Array<Maybe<Pathway>>>;
  show_bumper: Scalars['Boolean'];
  new?: Maybe<Scalars['Boolean']>;
};

export type VideoCategory = {
  __typename?: 'VideoCategory';
  id: Scalars['ID'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  parent_id?: Maybe<Scalars['ID']>;
  parent?: Maybe<VideoCategory>;
  title: Scalars['String'];
  slug: Scalars['String'];
  description: Scalars['String'];
  image_url: Scalars['String'];
};

export type VideoCategorySearchFilter = {
  parent_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
  orderBy?: Maybe<Array<OrderByClause>>;
};

export type VideoContentGroup = {
  __typename?: 'VideoContentGroup';
  id: Scalars['ID'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  title: Scalars['String'];
  icon_url: Scalars['String'];
};

export type VideoContentGroupSearchFilter = {
  title: Scalars['String'];
};

export type VideoDifficulty = {
  __typename?: 'VideoDifficulty';
  id: Scalars['ID'];
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  title: Scalars['String'];
  icon_url: Scalars['String'];
};

export type VideoDifficultySearchFilter = {
  title?: Maybe<Scalars['String']>;
};

export type VideoItem = {
  __typename?: 'VideoItem';
  ranking?: Maybe<Scalars['Int']>;
  video?: Maybe<Video>;
};

export type VideoListBlock = {
  __typename?: 'VideoListBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  orientation?: Maybe<Orientation>;
  background?: Maybe<Background>;
  items?: Maybe<Array<Maybe<VideoItem>>>;
};

export type VideoSearchFilter = {
  user_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  difficulty_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  video_url?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
  category_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  group_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  duration?: Maybe<Array<Maybe<Scalars['Int']>>>;
  ranking?: Maybe<Array<Maybe<Scalars['Int']>>>;
  demo?: Maybe<Array<Maybe<Scalars['Int']>>>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type VideoYouMightAlsoLikeFilter = {
  user_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  video_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum NavigationType {
  LogedIn = 'loged_in',
  LogedOut = 'loged_out',
  FooterLoggedIn = 'footer_logged_in',
  FooterLoggedOut = 'footer_logged_out',
}

export type NavigationItem = {
  __typename?: 'NavigationItem';
  ranking: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
  type: Scalars['String'];
  item_type: NavigationItemType;
};

export type Navigation = {
  __typename?: 'Navigation';
  id: Scalars['ID'];
  navigation_type?: Maybe<NavigationType>;
  tenant_id?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  items?: Maybe<Array<NavigationBlock>>;
};

export type NavigationBlock = NavigationItem | NavigationSection;

export type NavigationSection = {
  __typename?: 'NavigationSection';
  item_type: NavigationItemType;
  ranking: Scalars['Int'];
  title: Scalars['String'];
  items?: Maybe<Array<Maybe<NavigationItem>>>;
};

export enum NavigationItemType {
  Item = 'item',
  Section = 'section',
}

export type VideoContinueWatchingLinksFilter = {
  video_ids: Array<Maybe<Scalars['ID']>>;
  user_id: Scalars['ID'];
};

export type ContinueWatchingVideoLink = {
  __typename?: 'ContinueWatchingVideoLink';
  url?: Maybe<Scalars['String']>;
  chapter?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
};

export type VideoContinueWatchingLinksArgs = {
  filter?: Maybe<VideoContinueWatchingLinksFilter>;
};

export type VideoContinueWatchingLinksData = {
  listContinuingWatchingLinks?: Array<ContinueWatchingVideoLink>;
};

export type ViewedHoursGroupedByDate = {
  __typename?: 'ViewedHoursGroupedByDate';
  grouped_by_dates?: Maybe<Array<Maybe<ViewedHoursResDates>>>;
  grouped_by_users?: Maybe<Scalars['JSON']>;
  total_view_duration?: Maybe<Scalars['String']>;
  total_count_viewed_videos?: Maybe<Scalars['Int']>;
};

export type ViewedVideosGroupedByDate = {
  __typename?: 'ViewedVideosGroupedByDate';
  grouped_by_dates?: Maybe<Array<Maybe<ViewedVideosResDates>>>;
  grouped_by_users?: Maybe<Scalars['JSON']>;
  total_count_viewed_videos?: Maybe<Scalars['String']>;
};

export type ViewedVideosResDates = {
  __typename?: 'ViewedVideosResDates';
  date?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ViewedVideosResUser>>>;
};

export type ViewedVideosResUser = {
  __typename?: 'ViewedVideosResUser';
  user_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['String']>;
};

export type ViewedHoursResDates = {
  __typename?: 'ViewedHoursResDates';
  date?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ViewedHoursResUser>>>;
};

export type ViewedHoursResUser = {
  __typename?: 'ViewedHoursResUser';
  user_id?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['String']>;
};

export type ViewedHoursFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  story_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  category_id?: Maybe<Scalars['Int']>;
  group_by?: Maybe<GroupByPeriod>;
  type: TypeAnalytic;
};

export type ViewedHoursFilterArgs = {
  viewedHoursFilter: ViewedHoursFilter;
};

export type DateRangeFilter = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export enum GroupByPeriod {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export type ViewedVideosFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  story_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  category_id?: Maybe<Scalars['Int']>;
  group_by?: Maybe<GroupByPeriod>;
  type: TypeAnalytic;
};

export type ViewedVideosFilterArgs = {
  viewedVideosFilter: ViewedVideosFilter;
};

export type CpdCreditsFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  type: TypeAnalytic;
};

export type CpdCreditsFilterArgs = {
  cpdFilter: CpdCreditsFilter;
};

export type GroupedCpdCreditsResUsers = {
  __typename?: 'GroupedCpdCreditsResUsers';
  count?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<CpdCreditsResUsers>>>;
};

export type CpdCreditsResUsers = {
  __typename?: 'CpdCreditsResUsers';
  count?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type PathwayProgressFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  type: TypeAnalytic;
};

export type PathwayProgressFilterArgs = {
  pathwaysFilter: PathwayProgressFilter;
};

export type GroupedViewingPathwaysRes = {
  __typename?: 'GroupedViewingPathwaysRes';
  total_count_pathways?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<ViewingPathwaysResUsers>>>;
};

export type ViewingPathwaysResUsers = {
  __typename?: 'ViewingPathwaysResUsers';
  current?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type StatisticFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  category_id?: Maybe<Scalars['Int']>;
  type: TypeAnalytic;
};

export type StatisticFilterArgs = {
  statisticFilter?: Maybe<StatisticFilter>;
};

export type ViewedVideosGroupedByCategory = {
  __typename?: 'ViewedVideosGroupedByCategory';
  count?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<ViewedVideosByCategoryResUsers>>>;
  category?: Maybe<VideoCategory>;
};

export type ViewedVideosByCategoryResUsers = {
  __typename?: 'ViewedVideosByCategoryResUsers';
  user_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetAnalyticsForWidgetArgs = {
  statisticFilter: StatisticFilter;
  viewedHoursFilter: ViewedHoursFilter;
  viewedVideosFilter: ViewedVideosFilter;
};

export type GetAnalyticsForWidgetData = Pick<
  Query,
  | 'VideosWatchedByCathegoryStat'
  | 'ViewedHoursStat'
  | 'VideosWatchedCountStat'
  | 'listBaseVideoCategories'
>;

export type DashBoardContinueWatching = {
  __typename?: 'DashBoardContinueWatching';
  videos?: Maybe<Array<Maybe<DashVideo>>>;
  pathways?: Maybe<Array<Maybe<DashPath>>>;
};

export type DashVideo = {
  __typename?: 'DashVideo';
  last_position?: Maybe<Scalars['String']>;
  chapter?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  completed?: Maybe<Scalars['Boolean']>;
  progress_percentage?: Maybe<Scalars['Float']>;
};

export type DashPath = {
  __typename?: 'DashPath';
  pathway?: Maybe<Pathway>;
  videos_count?: Maybe<Scalars['Int']>;
};

export type ListDashboardArgs = {
  user_id: Scalars['ID'];
};

export type RecommendedVideosArgs = {
  user_id: Scalars['ID'];
};

export type ListLatestVideoArgs = {
  user_id: Scalars['ID'];
};

export type VideoNextInPathwayFilter = {
  video_id?: Maybe<Scalars['ID']>;
  user_id?: Maybe<Scalars['ID']>;
  last_viewed_pathway_slug?: Maybe<Scalars['String']>;
};

export type GetVideoNextInPathwayArgs = {
  filter?: Maybe<VideoNextInPathwayFilter>;
};

export type GetVideoNextInPathwayData = {
  getVideoNextInPathway?: Maybe<Video>;
};

export type GetContinueWatchingDataData = {
  listDashboard?: Maybe<Array<Maybe<DashBoardContinueWatching>>>;
};

export type VideoExistsInWatchListFilter = {
  user_id: Scalars['ID'];
  video_id: Scalars['ID'];
};

export type VideoExistsInWatchList = {
  __typename?: 'VideoExistsInWatchList';
  exists?: Maybe<Scalars['Int']>;
};

export type VideoInWatchList = {
  user_id: Scalars['ID'];
  video_id: Scalars['ID'];
};

export type VideoExistsInUserWatchListArgs = {
  filter: VideoExistsInWatchListFilter;
};

export type DashFeaturedVideo = {
  __typename?: 'DashFeaturedVideo';
  description?: Maybe<Scalars['String']>;
  video?: Maybe<FeaturedVideo>;
  title?: Maybe<Scalars['String']>;
};

export type FeaturedVideo = {
  __typename?: 'FeaturedVideo';
  id?: Maybe<Scalars['ID']>;
  preview_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GetDashBoardFeaturedVideos = {
  listFeaturedVideos: Array<DashFeaturedVideo>;
};

export type GetPageByUrlArgs = {
  url: String;
};

export interface IntrospectionResultData {
  __schema: {
    types: {
      kind: string;
      name: string;
      possibleTypes: {
        name: string;
      }[];
    }[];
  };
}

export type ListFeaturedExpertsArgs = {
  user_id: Scalars['ID'];
};

export type ListFeaturedExpertsData = Pick<Query, 'listFeaturedExperts'>;

export type UserVideosProgressRes = {
  videos_progresses?: Maybe<Array<Maybe<DashVideo>>>;
};

export type VideosProgressRes = {
  videos_progresses?: Maybe<Scalars['JSON']>;
};

export type PaginationStatFilter = {
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type VideosProgressFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  category_id?: Maybe<Scalars['Int']>;
  pagination?: PaginationStatFilter;
  type: TypeAnalytic;
};

export type UserVideosProgressStatArgs = {
  filter?: VideosProgressFilter;
};

export type UserVideosProgressStatData = Pick<Query, 'UserVideosProgressStat'>;

export type ManagerVideosProgressStatArgs = {
  filter?: VideosProgressFilter;
};

export type ManagerVideosProgressStatData = Pick<Query, 'ManagerVideosProgressStat'>;

export type AlgoliaApiKey = {
  __typename?: 'AlgoliaApiKey';
  api_key: Scalars['String'];
};

export type GetAlgoliaApiKeyData = Pick<Query, 'getAlgoliaApiKey'>;

export type UniqueVideoCategoryFilter = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type GetVideoCategoryArgs = {
  filter: UniqueVideoCategoryFilter;
};

export type GetVideoCategoryData = Pick<Query, 'getVideoCategory'>;

export type ListVideoCategoriesArgs = {
  filter?: Maybe<VideoCategorySearchFilter>;
  sort?: Maybe<Array<OrderByClause>>;
};

export type ListVideoCategoriesData = Pick<Query, 'listVideoCategories'>;

export type GetCategoriesByParentArgs = {
  parent_id?: Maybe<Array<Scalars['ID']>>;
};

export type DiscoverCategory = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type DiscoverVideo = {
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  duration: Scalars['Int'];
  description: Scalars['String'];
  preview_url?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  categories?: Maybe<Array<Maybe<VideoCategory>>>;
  difficulty?: Maybe<VideoDifficulty>;
};

export type DiscoverItems = {
  pathways?: Maybe<Array<Pathway>>;
  videos?: Maybe<Array<DiscoverVideo>>;
};

export type ListFeaturedVideosGroupByCategory = {
  items?: Maybe<Array<DiscoverItems>>;
  parentCategory?: Maybe<Array<DiscoverCategory>>;
  subCategories?: Maybe<Array<DiscoverCategory>>;
};

export type PathwayPage = {
  pathway?: Maybe<Pathway>;
};

export type PathwayPageLearner = {
  pathway?: Maybe<Pathway>;
  progress: Maybe<Array<Maybe<DashVideo>>>;
};

export type Quiz = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<QuizQuestion>>;
  percentage_complete?: Maybe<Scalars['Int']>;
  time_for_pass?: Maybe<Scalars['Int']>;
  count_of_questions?: Maybe<Scalars['Int']>;
  stars?: Maybe<Array<Scalars['String']>>;
  location?: Maybe<Scalars['String']>;
};

export type QuizQuestion = {
  blooms_taxonomy_type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  frontend_type?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  answers?: Maybe<Array<QuizQuestionAnswer>>;
  image?: Maybe<Scalars['String']>;
};

export type QuizQuestionAnswer = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type QuizAnswers = {
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  answer?: Maybe<Array<Scalars['String']>>;
};

export type PassedQuizInfo = {
  quiz_id: Scalars['Int'];
  tenant_id: Scalars['Int'];
  user_id: Scalars['Int'];
  pathway_id: Scalars['Int'];
  time_passing: Scalars['String'];
  questions: Maybe<Array<QuizAnswers>>;
};

export type GetPathwayPageInfoArgs = {
  slug: string;
};

export type GetPathwayPageInfoData = {
  getPathwayPageInfo?: Maybe<PathwayPage>;
};

export type GetPathwayLearnerPageInfoData = {
  getPathwayLearnerPageInfo?: Maybe<PathwayPageLearner>;
};

export type GetPathwaysYouMightAlsoLikeArgs = {
  slug: string;
};

export type GetPathwaysYouMightAlsoLikeData = {
  listYouMightAlsoLikePathways: Maybe<Array<Maybe<Pathway>>>;
};

export type UserSearchFilter = {
  id?: Maybe<Scalars['String']>;
  featured?: Maybe<Array<Maybe<Scalars['Int']>>>;
  email?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetExpertBySlugArgs = {
  slug: String;
};

export type GetExpertBySlugData = {
  getFilteredUsers?: Maybe<Array<Maybe<User>>>;
};

export type GetVideoBySlugOrIdArgs = {
  slug?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Array<Scalars['String']>>;
};

export type GetVideoBySlugOrIdData = {
  listVideos?: Maybe<Array<Video>>;
};

export type KeyLearningObjective = {
  id: Scalars['ID'];
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  title?: Scalars['String'];
  description?: Scalars['String'];
};

export type QuizPassedResult = {
  date_passing: Maybe<Scalars['String']>;
  percentage_complete: Maybe<Scalars['Int']>;
  count_of_questions: Maybe<Scalars['Int']>;
  count_correct_answers: Maybe<Scalars['Int']>;
  passed: Maybe<Scalars['Int']>;
  hash: Maybe<Scalars['String']>;
  pathway?: Maybe<Pathway>;
};

export type GetPassedQuizesResultsByHashData = Pick<Query, 'GetPassedQuizesResultsByHash'>;

export type GetPassedQuizesResultsByHashArgs = {
  hash: String;
};

export enum TypeAnalytic {
  User = 'user',
  Manager = 'manager',
}

export type GetVideoBySlugArgs = {
  slug?: Maybe<Array<Scalars['String']>>;
};

export type GetVideoBySlugData = {
  listVideos?: Maybe<Array<Video>>;
};

export type GetPassedQuizesByPathwayArgs = {
  quiz_ids: Array<Maybe<Scalars['Int']>>;
  pathway_id: Scalars['Int'];
};

export type GetPassedQuizesByPathwayData = Pick<Query, 'GetPassedQuizesResults'>;

export type ContactUsDepartment = {
  id: Scalars['ID'];
  tenant_id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
};

export type ContactUsDepartmentSearchFilter = {
  name: Scalars['String'];
};

export type ListContactUsDepartmentsData = Pick<Query, 'listContactUsDepartments'>;

export type AssignmentEntityInput = {
  type: Scalars['String'];
  id: Scalars['Int'];
};

export type AssignmentCreateInput = {
  relatable_group_type: AssignmentGroupType;
  relatable_group_ids: Array<Maybe<Scalars['Int']>>;
  title: Scalars['String'];
  description: Scalars['String'];
  due_date: Scalars['String'];
  assigned_entities: Array<Maybe<AssignmentEntityInput>>;
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentCpdCreateInput = {
  relatable_group_type: AssignmentGroupType;
  relatable_group_ids: Array<Maybe<Scalars['Int']>>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  due_date: Scalars['String'];
  target_cpd: Scalars['String'];
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentTeam = {
  __typename?: 'AssignmentTeam';
  id: Scalars['Int'];
  name: Scalars['String'];
  users?: Maybe<Array<Maybe<LearnerInfo>>>;
  users_count: Scalars['Int'];
};

export type AssignmentStatus = {
  __typename?: 'AssignmentStatus';
  assigned: Scalars['Int'];
  acknowledged: Scalars['Int'];
  started: Scalars['Int'];
  completed: Scalars['Int'];
};

export type AssignmentEntitiesCount = {
  __typename?: 'AssignmentEntitiesCount';
  entity_type: Scalars['String'];
  count: Scalars['Int'];
};

export type Assignment = {
  __typename?: 'Assignment';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  due_date: Scalars['String'];
  attached_to_group?: Maybe<AssignmentAttachedGroup>;
  status?: Maybe<AssignmentStatus>;
  start_date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  target_cpd?: Maybe<Scalars['String']>;
  target_hours?: Maybe<Scalars['Float']>;
  learners_count?: Maybe<Scalars['Int']>;
  entities_count?: Maybe<Array<Maybe<AssignmentEntitiesCount>>>;
  notification_settings?: Maybe<NotificationSettings>;
};

export enum NotificationSettings {
  Off = 'off',
  Auto = 'auto',
  Week = 'week',
  Month = 'month',
}

export type MutationCreateAssignmentArgs = {
  input: AssignmentCreateInput;
};

export type MutationCreateCpdAssignmentArgs = {
  input: AssignmentCpdCreateInput;
};

export type AssignmentEntity = Video | Pathway;

export type DetailedAssignmentStatusResponse = {
  user?: Maybe<LearnerInfo>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  videos_watched: Maybe<Scalars['Int']>;
  completed: Maybe<Scalars['Int']>;
  cpd_credits?: Maybe<Scalars['String']>;
  test_percent_complete?: Maybe<Scalars['Float']>;
  quiz_percentage_complete?: Maybe<Scalars['Int']>;
  stars?: Maybe<Array<Scalars['String']>>;
};

export type AssignmentDetailedInfo = {
  id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  entity?: Maybe<AssignmentEntity>;
  user_statuses?: Maybe<Array<Maybe<DetailedAssignmentStatusResponse>>>;
};

export type DetailedAssignmentResponse = {
  id?: Maybe<Scalars['Int']>;
  detailed_info?: Maybe<Array<Maybe<AssignmentDetailedInfo>>>;
};

export type GetDetailedListManagersArgs = {
  team_id: Scalars['Int'];
  assignment_id: Scalars['Int'];
};

export type QueryGet_Discover_Pathways_Detailed_InfoArgs = {
  pathway_ids: Array<Maybe<Scalars['Int']>>;
};

export type DiscoverPathwaysDetailedInfo = {
  __typename?: 'DiscoverPathwaysDetailedInfo';
  id?: Maybe<Scalars['Int']>;
  count_watched_videos?: Maybe<Scalars['Int']>;
  passed_quizes?: Maybe<Array<Maybe<DiscoverPathwaysPassedQuizInfo>>>;
  not_passed_quizes?: Maybe<Array<Maybe<DiscoverPathwaysNotPassedQuizInfo>>>;
};

export type DiscoverPathwaysNotPassedQuizInfo = {
  __typename?: 'DiscoverPathwaysNotPassedQuizInfo';
  id?: Maybe<Scalars['Int']>;
};

export type DiscoverPathwaysPassedQuizInfo = {
  __typename?: 'DiscoverPathwaysPassedQuizInfo';
  hash?: Maybe<Scalars['String']>;
  date_passing?: Maybe<Scalars['String']>;
};

export type UserAssignmentEntity = {
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  entity?: Maybe<AssignmentEntity>;
};

export type AssignmentForLearnerEntity =
  | AssignmentForLearner
  | AssignmentForLearnerCpd
  | AssignmentForLearnerHours
  | AssignmentForLearnerVideos;

export enum AssignmentForLearnerType {
  Pathway = 'pathway',
  Cpd = 'cpd',
  Hours = 'hours',
  Video = 'video',
}

export type AssignmentForLearner = {
  __typename?: 'AssignmentForLearner';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  due_date: Scalars['String'];
  progress?: Maybe<Scalars['Float']>;
  videos_watched?: Maybe<Scalars['Int']>;
  attached_to_group?: Maybe<AssignmentAttachedGroup>;
  status?: Maybe<AssignmentForLearnerStatus>;
  type?: Maybe<AssignmentForLearnerType>;
  entities?: Maybe<Array<Maybe<UserAssignmentEntity>>>;
  learners_count?: Maybe<Scalars['Int']>;
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentForLearnerVideos = {
  __typename?: 'AssignmentForLearnerVideos';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<AssignmentForLearnerType>;
  due_date: Scalars['String'];
  attached_to_group?: Maybe<AssignmentAttachedGroup>;
  learners_count?: Maybe<Scalars['Int']>;
  status: AssignmentForLearnerStatus;
  progress?: Maybe<Scalars['Float']>;
  videos_watched?: Maybe<Scalars['Int']>;
  entities?: Maybe<Array<Maybe<UserAssignmentEntity>>>;
  entities_count?: Maybe<Array<Maybe<AssignmentEntitiesCount>>>;
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentForLearnerCpd = {
  __typename?: 'AssignmentForLearnerCPD';
  start_date?: Maybe<Scalars['String']>;
  target_cpd?: Maybe<Scalars['String']>;
  cpd_credits?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  due_date: Scalars['String'];
  videos_watched?: Maybe<Scalars['Int']>;
  attached_to_group?: Maybe<AssignmentAttachedGroup>;
  learners_count?: Maybe<Scalars['Int']>;
  status?: Maybe<AssignmentForLearnerStatus>;
  type?: Maybe<AssignmentForLearnerType>;
  entities?: Maybe<Array<Maybe<UserAssignmentEntity>>>;
  notification_settings?: Maybe<NotificationSettings>;
};

export type AssignmentForLearnerHours = {
  __typename?: 'AssignmentForLearnerHours';
  start_date?: Maybe<Scalars['String']>;
  target_hours?: Maybe<Scalars['String']>;
  watched_hours?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<AssignmentForLearnerType>;
  due_date: Scalars['String'];
  videos_watched?: Maybe<Scalars['Int']>;
  attached_to_group?: Maybe<AssignmentAttachedGroup>;
  learners_count?: Maybe<Scalars['Int']>;
  status?: Maybe<AssignmentForLearnerStatus>;
  entities?: Maybe<Array<Maybe<UserAssignmentEntity>>>;
  notification_settings?: Maybe<NotificationSettings>;
};

export enum AssignmentForLearnerStatus {
  Assigned = 'assigned',
  Acknowledged = 'acknowledged',
}

export enum NotificationType {
  Reminder = 'reminder',
  New = 'new',
}

export type UsersProgressOnVideoFilter = {
  date?: Maybe<DateRangeFilter>;
  story_id: Scalars['ID'];
  user_ids: Array<Maybe<Scalars['Int']>>;
  pagination_option: PaginationOption;
};

export type UsersProgressOnVideoArgs = {
  filter: UsersProgressOnVideoFilter;
};

export type UsersProgressOnVideoFilterResponse = {
  __typename?: 'UsersProgressOnVideoFilterResponse';
  user?: Maybe<LearnerInfo>;
  user_id?: Maybe<Scalars['Int']>;
  view_finish?: Maybe<Scalars['String']>;
  view_duration?: Maybe<Scalars['String']>;
  complete?: Maybe<Scalars['Boolean']>;
  last_position?: Maybe<Scalars['String']>;
  progress_percentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type UsersProgressOnPathwaysFilter = {
  date?: Maybe<DateRangeFilter>;
  pathway_id: Scalars['ID'];
  user_ids: Array<Maybe<Scalars['Int']>>;
  pagination_option: PaginationOption;
};

export type UsersProgressOnPathwaysArgs = {
  filter: UsersProgressOnPathwaysFilter;
};

export type DiscoverPathwaysDetailedInfofForUsers = {
  __typename?: 'DiscoverPathwaysDetailedInfofForUsers';
  id?: Maybe<Scalars['String']>;
  user?: Maybe<LearnerInfo>;
  count_watched_videos?: Maybe<Scalars['Int']>;
  passed_quizes?: Maybe<Array<Maybe<DiscoverPathwaysPassedQuizInfoForUsers>>>;
  not_passed_quizes?: Maybe<Array<Maybe<DiscoverPathwaysNotPassedQuizInfo>>>;
};

export type DiscoverPathwaysPassedQuizInfoForUsers = {
  __typename?: 'DiscoverPathwaysPassedQuizInfoForUsers';
  hash?: Maybe<Scalars['String']>;
  date_passing?: Maybe<Scalars['String']>;
  percentage_complete?: Maybe<Scalars['String']>;
};

export type PaginationOption = {
  page: Scalars['Int'];
  count_items_on_page: Scalars['Int'];
};

export type PricingType = {
  __typename?: 'PricingType';
  id: Scalars['ID'];
  tenant?: Tenant;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  title?: Maybe<Scalars['String']>;
};

export type PricingDuration = {
  __typename?: 'PricingDuration';
  id: Scalars['ID'];
  tenant?: Tenant;
  title?: Maybe<Scalars['String']>;
};

export type ChargebeePlanInfo = {
  min_team_members: Scalars['Int'];
  max_team_members: Scalars['Int'];
  price?: Maybe<Scalars['String']>;
  price_with_tax?: Maybe<Scalars['String']>;
  is_taxable?: Maybe<Scalars['Int']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  id: Scalars['ID'];
  chargebee_plan_id: Scalars['String'];
  tenant?: Tenant;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  pricing_type: PricingType;
  pricing_duration: PricingDuration;
  title: Scalars['String'];
  description: Scalars['String'];
  chargebee_plan_info?: Maybe<ChargebeePlanInfo>;
  enterprise: Scalars['Int'];
  features_heading: Scalars['String'];
  features: Array<Scalars['String']>;
  free_trial_period?: Maybe<FreeTrialPeriod>;
};

export type GetPricesListArgs = {
  pricingDurationId: number;
};

export type GetChargeBeePlanInfoArgs = {
  chargeBeePlanId: string;
};

export enum AuthSource {
  Auth0 = 'auth0',
  Linkedin = 'linkedin',
}

export type Company = {
  __typename?: 'Company';
  id: Scalars['ID'];
  name: Scalars['String'];
  owner_id: Scalars['Int'];
  short_name?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
};

export type CompanyEditInput = {
  short_name?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
};

export type MutationEditCompanyArgs = {
  input: CompanyEditInput;
};

export enum TeamRole {
  Manager = 'manager',
  Member = 'member',
  Owner = 'owner',
}

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID'];
  name: Scalars['String'];
  company_id: Scalars['Int'];
  company?: Maybe<Company>;
  managers?: Maybe<Array<Maybe<LearnerInfo>>>;
  learner_role?: Maybe<TeamRole>;
  all_members_count?: Maybe<Scalars['Int']>;
};

export type LearnerInfo = {
  __typename?: 'LearnerInfo';
  id: Scalars['ID'];
  auth0_id?: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  auth_source?: Maybe<AuthSource>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  teams?: Maybe<Array<Maybe<Team>>>;
  is_manager?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  has_subscription?: Scalars['Boolean'];
  had_subscription?: Scalars['Boolean'];
  sub_provided_by_chargebee_site?: Maybe<Scalars['String']>;
  owned_subscription?: Scalars['Boolean'];
  job?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<VideoCategory>>>;
  last_login?: Maybe<Scalars['String']>;
};

export type AssignmentEntityStatusResponse = {
  __typename?: 'AssignmentEntityStatusResponse';
  user?: Maybe<LearnerInfo>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  videos_watched?: Maybe<Scalars['Int']>;
  completed?: Maybe<Scalars['Int']>;
  test_percent_complete?: Maybe<Scalars['Float']>;
  quiz_percentage_complete?: Maybe<Scalars['Int']>;
  stars?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AssignmentEntityInfo = {
  __typename?: 'AssignmentEntityInfo';
  id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  entity?: Maybe<AssignmentEntity>;
  started: Scalars['Int'];
  completed: Scalars['Int'];
};

export type ListEntitiesAssignmentResponse = {
  __typename?: 'ListEntitiesAssignmentResponse';
  id?: Maybe<Scalars['Int']>;
  entities?: Maybe<Array<Maybe<AssignmentEntityInfo>>>;
  entities_count?: Maybe<Array<Maybe<AssignmentEntitiesCount>>>;
};

export type FreeTrialPeriod = {
  count?: Scalars['Int'];
  unit?: Scalars['String'];
};

export type SubscriptionChargebeeThankYouInfo = {
  __typename?: 'SubscriptionChargebeeThankYouInfo';
  type?: Maybe<Scalars['String']>;
  organization_name?: Maybe<Scalars['String']>;
  number_of_learners?: Maybe<Scalars['Int']>;
  total_price: Scalars['String'];
  free_trial_period?: Maybe<FreeTrialPeriod>;
  billing_starts?: Maybe<Scalars['String']>;
  payment_frequency?: Maybe<Scalars['String']>;
  renews_automaticly_on?: Maybe<Scalars['String']>;
  invoice_link?: Maybe<Scalars['String']>;
  subscription_group_type?: Maybe<SubscriptionGroupType>;
};

export type GetTeamManagersArgs = {
  team_id?: Scalars['ID'];
};

export type TeamInviteLink = {
  id: Scalars['ID'];
  hash: Scalars['String'];
  team_id: Scalars['Int'];
};

export type GetTeamInviteLinkArgs = {
  team_id: Scalars['Int'];
};

export type LearnerEditInput = {
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  job?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UpdateLearnerInfoArgs = {
  input: LearnerEditInput;
};

export type TeamInviteInfo = {
  __typename?: 'TeamInviteInfo';
  team_name?: Scalars['String'];
  company?: Company;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  seats_available?: Maybe<Scalars['Int']>;
};

export type GetTeamInviteInfoArgs = {
  hash: String;
};

export type JoinTeamByInviteHashArgs = {
  hash: String;
};

export type RemainingTrials = {
  __typename?: 'RemainingTrials';
  left?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  left_unit?: Maybe<Scalars['String']>;
  total_unit?: Maybe<Scalars['String']>;
};

export type Seats = {
  __typename?: 'Seats';
  occupied_seats?: Maybe<Scalars['Int']>;
  bought_seats?: Maybe<Scalars['Int']>;
  max_count_seats_in_plan?: Maybe<Scalars['Int']>;
};

export type AssignmentCpdStatusResponse = {
  __typename?: 'AssignmentCPDStatusResponse';
  user?: Maybe<LearnerInfo>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Int']>;
  cpd_credits?: Maybe<Scalars['String']>;
  test_percent_complete?: Maybe<Scalars['Float']>;
  quiz_percentage_complete?: Maybe<Scalars['Int']>;
  stars?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type getListEntitiesAssignmentManagerArgs = {
  team_id: Scalars['Int'];
  assignment_id: Scalars['Int'];
};

export type getEntityAssignmentStatusesInfoManagerArgs = {
  assignment_id: Scalars['Int'];
  entity: AssignmentEntityInput;
  pagination_option: PaginationOption;
};

export type getCPDAssignmentDetailedInfoManagerArgs = {
  assignment_id: Scalars['Int'];
  pagination_option: PaginationOption;
};

export type CtaBlock = {
  __typename?: 'CTABlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  background?: Maybe<Background>;
  title?: Maybe<Scalars['String']>;
  sub_title?: Maybe<Scalars['String']>;
  title_text?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type MySubscriptionCompanyOwnerChargebeeInfo = {
  __typename?: 'MySubscriptionCompanyOwnerChargebeeInfo';
  type?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  renews_automaticly_on?: Maybe<Scalars['String']>;
  remaining_trials?: Maybe<RemainingTrials>;
  seats?: Maybe<Seats>;
  subscription_group_type?: Maybe<SubscriptionGroupType>;
  current_term_end?: Maybe<Scalars['String']>;
  is_cancelled: Scalars['Boolean'];
};

export type MySubscriptionTeamManagerChargebeeInfo = {
  __typename?: 'MySubscriptionTeamManagerChargebeeInfo';
  type?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  renews_automaticly_on?: Maybe<Scalars['String']>;
  subscription_group_type?: Maybe<SubscriptionGroupType>;
};

export type MySubscriptionB2BLearnerChargebeeInfo = {
  __typename?: 'MySubscriptionB2BLearnerChargebeeInfo';
  type?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  renews_automaticly_on?: Maybe<Scalars['String']>;
  subscription_group_type?: Maybe<SubscriptionGroupType>;
};

export type MySubscriptionB2CLearnerChargebeeInfo = {
  __typename?: 'MySubscriptionB2CLearnerChargebeeInfo';
  type?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  renews_automaticly_on?: Maybe<Scalars['String']>;
  remaining_trials?: Maybe<RemainingTrials>;
  subscription_id?: Maybe<Scalars['String']>;
  subscription_group_type?: Maybe<SubscriptionGroupType>;
  current_term_end?: Maybe<Scalars['String']>;
  is_cancelled: Scalars['Boolean'];
};

export enum USER_ROLES {
  CompanyOwner = 'company_owner',
  TeamManager = 'team_manager',
  B2BLearner = 'b2b_learner',
  B2CLearner = 'b2c_learner',
  LearnerWithoutSubscription = 'learner_without_subscription',
}

export type GetTeamArgs = {
  id: Scalars['ID'];
};

export type GetTeamMembersArgs = {
  team_id: Scalars['ID'];
};

export type TeamCreateInput = {
  input: { name: Scalars['String'] };
};

export type TeamUpdateInput = {
  input: TeamUpdateArgs;
};

export type TeamUpdateArgs = {
  name: Scalars['String'];
  team_id: Scalars['ID'];
};

export type TeamMemberRole = {
  input: TeamMemberRoleInput;
};

export type TeamMemberRoleInput = {
  team_id: Scalars['ID'];
  member_id: Scalars['ID'];
  member_role: TeamRole;
};

export type TeamDeleteInput = {
  input: { team_id: Scalars['ID'] };
};

export type MoveLearnerInOtherTeamInput = {
  input: MoveLearnerInOtherTeamArgs;
};

export type MoveLearnerInOtherTeamArgs = {
  from_team: Scalars['ID'];
  id: Scalars['ID'];
  to_team: Scalars['ID'];
};

export type GetMembersByTeamIdsArgs = {
  team_ids: Maybe<Array<Maybe<Scalars['Int']>>>;
};

const possibleTypes = {
  Block: [
    'VideoListBlock',
    'PathwayListBlock',
    'NewsBlock',
    'ImageArrayBlock',
    'IntroVideoBlock',
    'IntroImageBlock',
    'PartnersBlock',
    'ExpertsListBlock',
    'OriginsBlock',
  ],
  Content: ['TextContent', 'ImageContent'],
};

export type QuotesListBlock = {
  __typename?: 'QuotesListBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  background?: Maybe<Background>;
  background_image?: Maybe<Scalars['String']>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
};

export type Quote = {
  __typename?: 'Quote';
  ranking?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  color_text?: Maybe<Scalars['String']>;
  sub_title?: Maybe<Scalars['String']>;
  cta_button_link?: Maybe<Scalars['String']>;
  cta_button_text?: Maybe<Scalars['String']>;
};

export type GetHasNewsResponse = {
  hasNews?: boolean;
};

export enum PATHWAY_STATUSES {
  NOT_WATCHED = 'not-watched',
  STARTED = 'started',
  WATCHED = 'watched',
  HAS_TEST_SCORE = 'has-test-score',
  COMPLETED = 'completed',
}

export enum VIDEO_STATUSES {
  NOT_STARTED = 'not-started',
  STARTED = 'started',
  COMPLETED = 'completed',
}

export type NotificationForAssignment = {
  __typename?: 'NotificationForAssignment';
  id: Scalars['String'];
  type: NotificationType;
  assignment: Assignment;
};

export type NotificationUpdateInput = {
  notification_id: Scalars['Int'];
  notification_status: Scalars['Boolean'];
};

export enum ReviewableType {
  Pathway = 'pathway',
  Video = 'video',
  Course = 'course',
}

type ReviewEntity = {
  count_reviews: Scalars['Int'];
  general_star_rating: Scalars['Int'];
  reviews: Array<Review>;
};

export type Review = {
  stars_rating: Scalars['Int'];
  created_at: Scalars['String'];
  comment: Scalars['String'];
  learner: LearnerInfo;
};

export type listReviewsArgs = {
  entity_type: ReviewableType;
  entity_id: Scalars['ID'];
  pagination_option: PaginationOption;
};

export type ReviewCreateInput = {
  comment: Maybe<Scalars['String']>;
  stars_rating: Scalars['Int'];
  reviewable_type: ReviewableType;
  reviewable_id: Scalars['Int'];
};

export type ContactFormBlock = {
  __typename?: 'ContactFormBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  sub_title?: Maybe<Scalars['String']>;
  background_image?: Maybe<Scalars['String']>;
  user_com_formId?: Maybe<Scalars['String']>;
  name_field?: Maybe<Scalars['String']>;
  email_field?: Maybe<Scalars['String']>;
  contact_reason_field?: Maybe<Scalars['String']>;
  contact_message_field?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ContactFormItem>>>;
};

export type MeetTheTeam = {
  __typename?: 'MeetTheTeam';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  members?: Maybe<Array<Maybe<Expert>>>;
};

export type ContactFormItem = {
  __typename?: 'ContactFormItem';
  question?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  is_sales_request?: Maybe<Scalars['Boolean']>;
};

export enum ASSIGNMENT_STATUSES {
  ASSIGNED = 'Assigned',
  ACKNOWLEDGED = 'Acknowledged',
  STARTED = 'Started',
  WATCHED = 'Watched',
  COMPLETED = 'Completed',
}

export type GroupedByUsersStatResult = {
  __typename?: 'GroupedByUsersStatResult';
  users_stat?: Maybe<Scalars['JSON']>;
};

export type GroupedByUsersFilter = {
  date?: Maybe<DateRangeFilter>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  pagination_option?: Maybe<PaginationOption>;
};

export type QueryGroupedByUsersStatArgs = {
  filter?: Maybe<GroupedByUsersFilter>;
};

export type PathwayProgressesRes = {
  __typename?: 'PathwayProgressesRes';
  pathway_watched_videos_count?: Maybe<Scalars['Int']>;
  pathway_videos_count?: Maybe<Scalars['Int']>;
  progress?: Maybe<Scalars['Float']>;
  test_score?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  pathway?: Maybe<Pathway>;
};

export type CpdCreditsStatRes = {
  __typename?: 'CpdCreditsStatRes';
  completed?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type PathwaysStatRes = {
  __typename?: 'PathwaysStatRes';
  completed?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PathwaysUserStatResult = {
  __typename?: 'PathwaysUserStatResult';
  pathways_progresses_stat?: Maybe<Array<Maybe<PathwayProgressesRes>>>;
  cpd_credits_stat?: Maybe<CpdCreditsStatRes>;
  pathways_stat?: Maybe<PathwaysStatRes>;
};

export type QueryGetUserPathwaysProgressStatArgs = {
  filter?: Maybe<PathwayProgressFilter>;
};
export type ProgressByPathway = {
  __typename?: 'ProgressByPathway';
  user?: Maybe<LearnerInfo>;
  progress?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  watched_videos_count?: Maybe<Scalars['Int']>;
  pathway_videos_count?: Maybe<Scalars['Int']>;
  test_score?: Maybe<Scalars['Float']>;
};

export type QueryGetUsersProgressesByPathwayArgs = {
  filter?: Maybe<UsersProgressOnPathwaysFilter>;
};

export type ProgressByCpd = {
  __typename?: 'ProgressByCPD';
  user?: Maybe<LearnerInfo>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  cpd_available?: Maybe<Scalars['Float']>;
};

export type ProgressByHours = {
  __typename?: 'ProgressByHours';
  user?: Maybe<LearnerInfo>;
  status?: Maybe<Scalars['String']>;
  status_date?: Maybe<Scalars['String']>;
  hours_watched?: Maybe<Scalars['Float']>;
};

export type CourseGeneralInfo = {
  __typename?: 'CourseGeneralInfo';
  pathways?: Maybe<Scalars['String']>;
  learning_hours?: Maybe<Scalars['String']>;
  cpd_credits?: Maybe<Scalars['String']>;
  videos?: Maybe<Scalars['String']>;
  experts?: Maybe<Scalars['String']>;
};

export type CoursePartner = {
  __typename?: 'CoursePartner';
  ranking?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export type Course = {
  __typename?: 'Course';
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  pathways?: Maybe<Array<Maybe<Pathway>>>;
  key_learning_objectives?: Maybe<Array<Maybe<KeyLearningObjective>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  navigation_description: Scalars['String'];
  image_url: Scalars['String'];
  svg_icon?: Maybe<Scalars['String']>;
  intro_verse_video_id?: Maybe<Scalars['Int']>;
  about_course?: Maybe<Scalars['String']>;
  who_is_this_for?: Maybe<Scalars['String']>;
  experts?: Maybe<Array<Maybe<Expert>>>;
  requirements?: Maybe<Scalars['String']>;
  partners?: Maybe<Array<Maybe<CoursePartner>>>;
  general_info?: Maybe<CourseGeneralInfo>;
  usp_blocks?: Maybe<Array<Maybe<Usp_Block>>>;
  progress?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
};

export type CourseDropdownItem = {
  id?: string;
  name?: string | null;
  navigationDescription?: string | null;
  slug?: string;
  isStarted: boolean;
};

export enum COURSE_STATUSES {
  STARTED = 'started',
  NOT_STARTED = 'not_started',
  COMPLETED = 'completed',
}

export type CourseSearchFilter = {
  __typename?: 'CourseSearchFilter';
  id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export type GetCourseArgs = {
  slug?: Maybe<Scalars['String']>;
};

export type MutationStartCourseArgs = {
  course_id: Scalars['Int'];
};

export type GetCourseProgressArgs = {
  slug?: Maybe<Scalars['String']>;
};

type CourseStatusModel = {
  learner: Maybe<LearnerInfo>;
  course: Maybe<Course>;
  status: Maybe<COURSE_STATUSES>;
  hash: Maybe<Scalars['String']>;
  completed_at: Maybe<Scalars['String']>;
};

export type GetCourseStatusByHashArgs = {
  hash: Maybe<Scalars['String']>;
};

export type UspIconBlock = {
  __typename?: 'USPIconBlock';
  usp_icon_image?: Maybe<Scalars['String']>;
  usp_title?: Maybe<Scalars['String']>;
  usp_description?: Maybe<Scalars['String']>;
};

export type Section_First = {
  __typename?: 'Section_First';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Section_Second = {
  __typename?: 'Section_Second';
  title?: Maybe<Scalars['String']>;
  usp_icon_block?: Maybe<Array<Maybe<UspIconBlock>>>;
};

export type WhatBusinessStand = {
  __typename?: 'WhatBusinessStand';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  section_first?: Maybe<Section_First>;
  section_second?: Maybe<Section_Second>;
};

export type QueryGetManagerDetailedReportByPathwaysArgs = {
  filter?: InputMaybe<DetailedReportFilter>;
};

export type DetailedReportByPathways = {
  __typename?: 'DetailedReportByPathways';
  items?: Maybe<Array<Maybe<DetailedReportByPathwaysItem>>>;
  count?: Maybe<Scalars['Int']>;
};

export type DetailedReportByPathwaysItem = {
  __typename?: 'DetailedReportByPathwaysItem';
  pathway_id: Scalars['Int'];
  pathway_slug: Scalars['String'];
  pathway_duration?: Maybe<Scalars['Int']>;
  pathway_name: Scalars['String'];
  videos_count: Scalars['Int'];
  videos_completed: Scalars['Int'];
  test_passed: Scalars['Boolean'];
  test_score: Scalars['Int'];
  progress: Scalars['Int'];
  status: Scalars['String'];
  learner: LearnerInfo;
};

export type DetailedReportFilter = {
  learner_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  team_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  date?: InputMaybe<DateRangeFilter>;
  pagination_option?: InputMaybe<PaginationOption>;
};

export type AssignmentHoursCreateInput = {
  relatable_group_type: AssignmentGroupType;
  relatable_group_ids: Array<Maybe<Scalars['Int']>>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  due_date: Scalars['String'];
  target_hours: Scalars['String'];
  notification_settings?: Maybe<NotificationSettings>;
};

export type WeAreBlockItem = {
  __typename?: 'WeAreBlockItem';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type WeAreBlockSlider = {
  __typename?: 'WeAreBlockSlider';
  image?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type WeAreBlock = {
  __typename?: 'WeAreBlock';
  type?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  items?: Maybe<Array<Maybe<WeAreBlockItem>>>;
  sliders?: Maybe<Array<Maybe<WeAreBlockSlider>>>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  learner?: Maybe<LearnerInfo>;
  role?: Maybe<TeamRole>;
};

export type DetailedReportByVideos = {
  __typename?: 'DetailedReportByVideos';
  items?: Maybe<Array<Maybe<DetailedReportByVideosItem>>>;
  count?: Maybe<Scalars['Int']>;
};

export type DetailedReportByVideosItem = {
  __typename?: 'DetailedReportByVideosItem';
  video?: Maybe<Video>;
  learner: LearnerInfo;
  completed: Scalars['Boolean'];
  progress: Scalars['Int'];
};

export type QueryGetManagerDetailedReportByVideosArgs = {
  filter?: InputMaybe<DetailedReportFilter>;
};

export type MutationCreateAssignmentHoursArgs = {
  input: AssignmentHoursCreateInput;
};

export enum SubscriptionGroupType {
  Individual = 'individual',
  Team = 'team',
  Enterprise = 'enterprise',
}

export type PathwayCertificate = {
  __typename?: 'PathwayCertificate';
  pathway: Pathway;
  hash: Scalars['String'];
  date_passing?: Maybe<Scalars['String']>;
};

export type CertificatesFilter = {
  __typename?: 'CertificatesFilter';
  date?: Maybe<DateRangeFilter>;
};

export type QueryGetPathwayCertificatesArgs = {
  filter?: InputMaybe<CertificatesFilter>;
};

export type QueryVideosExistInUserWatchListArgs = {
  video_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type VideosExistInWatchList = {
  __typename?: 'VideosExistInWatchList';
  video_id: Scalars['ID'];
  exists: Scalars['Boolean'];
};

export type AssignmentGroupEntity = Team | Company;

export enum AssignmentGroupType {
  Team = 'team',
  Company = 'company',
}

export type AssignmentAttachedGroup = {
  __typename?: 'AssignmentAttachedGroup';
  type?: Maybe<AssignmentGroupType>;
  group?: Maybe<AssignmentGroupEntity>;
};

export default possibleTypes;
